import dayjs from "dayjs";

export const parseTime = ( str: string|number ) => {
    if(!str || `${str}` === '---') {
        return null;
    }

    if(typeof str === 'object') {
        return dayjs(str);
    }

    let timeParts = [`${str}`];
    if(!!`${str}`.match(/\|/i)) {
        timeParts = `${str}`.split('|');
    }
    const tmpParts = [ ...timeParts ];
    tmpParts.forEach((part, index) => {
        if(!!`${part}`.match(/:/i)) {
            const tmp = part.trim().split(':');
            timeParts.splice(timeParts.indexOf(part), 1);
            timeParts = [ ...timeParts, ...tmp];
        }
    });

    const date = new Date();
    switch(timeParts.length) {
        case 3  : date.setSeconds(parseInt(timeParts[2])); // falls through
        case 2  : date.setMinutes(parseInt(timeParts[1])); // falls through
        case 1  : date.setHours(parseInt(timeParts[0]));   // falls through

        default : break;
    }

    return dayjs(date);
};

